/**
 * Smooth Scroll Module
 * Handles smooth scrolling to anchor links with dynamic header offset
 */
const SmoothScroll = {
	init() {
		// Use capture phase to intercept clicks before other handlers
		document.addEventListener('click', (e) => {
			const target = e.target.closest('a[href*="#"]');
			
			if (!target) {
				return;
			}

			const href = target.getAttribute('href');
			
			// Make sure it's an anchor link and not just a hash
			if (!href || href === '#' || href.indexOf('#') === -1) {
				return;
			}

			// Extract the hash/anchor from the href
			const hash = href.split('#')[1];
			
			if (!hash) {
				return;
			}

			// Check if the target element exists
			const targetElement = document.getElementById(hash);
			
			if (!targetElement) {
				return;
			}

			// Prevent default anchor behavior
			e.preventDefault();
			e.stopPropagation();

			// Scroll to target with position correction
			this.scrollToTarget(targetElement, hash);
		}, true); // Use capture phase to run before other handlers
	},

	/**
	 * Scroll to target element with position correction to handle dynamic content loading
	 */
	scrollToTarget(targetElement, hash) {
		// Calculate offset based on header height
		const offset = this.calculateOffset();
		
		// Get initial target position
		const initialPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
		let scrollToPosition = initialPosition - offset;
		
		// Check if we're trying to scroll past the bottom of the page
		const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
		if (scrollToPosition > maxScroll) {
			scrollToPosition = maxScroll;
		}
		
		// Smooth scroll to the position
		window.scrollTo({
			top: scrollToPosition,
			behavior: 'smooth'
		});

		// Recalculate and correct position after a short delay
		// This handles cases where images/content load during the scroll animation
		setTimeout(() => {
			const currentPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
			const correctedPosition = currentPosition - offset;
			
			// Only correct if the position has shifted significantly (more than 10px)
			if (Math.abs(correctedPosition - scrollToPosition) > 10) {
				const finalMaxScroll = document.documentElement.scrollHeight - window.innerHeight;
				const finalPosition = Math.min(correctedPosition, finalMaxScroll);
				
				window.scrollTo({
					top: finalPosition,
					behavior: 'smooth'
				});
			}
		}, 100);

		// Do a final check after content should be fully settled
		setTimeout(() => {
			const finalPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
			const finalCorrectedPosition = finalPosition - offset;
			const currentScroll = window.pageYOffset;
			
			// Only correct if we're still off by more than 10px
			if (Math.abs(currentScroll - finalCorrectedPosition) > 10) {
				const finalMaxScroll = document.documentElement.scrollHeight - window.innerHeight;
				const scrollTo = Math.min(finalCorrectedPosition, finalMaxScroll);
				
				window.scrollTo({
					top: scrollTo,
					behavior: 'smooth'
				});
			}
		}, 600);

		// Update the URL hash (optional, but good for bookmarking)
		if (history.pushState) {
			history.pushState(null, null, '#' + hash);
		} else {
			window.location.hash = hash;
		}
	},

	/**
	 * Calculate the offset based on fixed headers (main header + admin bar if logged in)
	 */
	calculateOffset() {
		let offset = 0;

		// Get main header height dynamically
		const mainHeader = document.getElementById('main-header');
		if (mainHeader) {
			offset += mainHeader.offsetHeight;
		}

		// Add WordPress admin bar height if it exists (when logged in)
		const adminBar = document.getElementById('wpadminbar');
		if (adminBar) {
			offset += adminBar.offsetHeight;
		}
		return offset;
	}
};

export default SmoothScroll;
